import React, { useEffect, useState } from "react";
import { Applogo } from "../../../Routes/ImagePath";
import AuthUser from "../../../components/AuthUser";
import Spinner from "../../../components/Spinner";
import { Link, useNavigate } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useDispatch } from "react-redux";

import { Controller, useForm } from "react-hook-form";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { http, setToken } = AuthUser();

  const details = localStorage.getItem("loginDetails");

  const loginData = JSON.parse(details);

  const navigate = useNavigate();

  const {
    register,
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [permissaoVer, setPermissaoVer] = useState(9);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  function refreshPage() {
    window.location.reload(false);
  }

  const onSubmit = async () => {
    localStorage.setItem("colorschema", "orange");
    localStorage.setItem("layout", "vertical");
    localStorage.setItem("layoutwidth", "fixed");
    localStorage.setItem("layoutpos", "fluid");
    localStorage.setItem("topbartheme", "light");
    localStorage.setItem("layoutSized", "lg");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutSidebarStyle", "dark");

    try {
      setLoading(true);

      const res = await http.post("/login", {
        email: email,
        password: password,
      });

      toast.success("Credências aceite com sucesso!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          setToken(
            res.data.user,
            res.data.permissoes,
            res.data.access_token,
            res.data.empresa,
            res.data.multipla_visibilidade,
            res.data.user.missao,
            res.data.missoes,
            res.data.contacto
          );

          setPermissaoVer(res.data.user.nivel_id);

          if (res.data.multipla_visibilidade || res.data.user.tipo == 1)
            navigate("/admin-dashboard");
          else navigate("/admin-dashboard");
        },
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Credências inválidas, tente novamente!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error("Algo correu mal, tente novamente mais tarde!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setValue("email", localStorage.getItem("email"));
    setValue("password", localStorage.getItem("password"));
  }, []);

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  const [verLogin, seVerLogin] = useState(true);

  const onLoginClick = () => {
    seVerLogin(true);
  };

  const cronograma = [
    {
      semana: "Semana 1",
      periodo: "19/04/2025 a 25/04/2025",
      atividade:
        "Planeamento geral do sistema, estrutura do banco de dados, arquitetura de pastas, configuração do ambiente de desenvolvimento e controle de versão.",
      reuniao: "Sabado,  19/04/2025",
    },
    {
      semana: "Semana 2",
      periodo: "26/04/2025 a 02/05/2025",
      atividade:
        "Desenvolvimento do módulo de colaboradores: formulários de registo, uploads de documentos, filtros e página de listagem.",
      reuniao: "Sabado,  26/04/2025",
    },
    {
      semana: "Semana 3",
      periodo: "03/05/2025 a 09/05/2025",
      atividade:
        "Desenvolvimento do módulo de clientes e projetos: criação, edição e vinculação entre projetos, clientes e colaboradores.",
      reuniao: "Sabado,  03/05/2025",
    },
    {
      semana: "Semana 4",
      periodo: "10/05/2025 a 16/05/2025",
      atividade:
        "Implementação do módulo de certificações: registo de tipos e níveis, upload de certificados, alertas e filtros personalizados.",
      reuniao: "Sabado,  10/05/2025",
    },
    {
      semana: "Semana 5",
      periodo: "17/05/2025 a 23/05/2025",
      atividade:
        "Módulo de contratos e atividades marítimas: registo de contratos, entradas e saídas (crew change), validação de repouso legal.",
      reuniao: "Sabado,  17/05/2025",
    },
    {
      semana: "Semana 6",
      periodo: "24/05/2025 a 30/05/2025",
      atividade:
        "Módulo de registo de férias, inabilitações, controle de operações do sistema e gestão de logs.",
      reuniao: "Sabado,  24/05/2025",
    },
    {
      semana: "Semana 7",
      periodo: "31/05/2025 a 06/06/2025",
      atividade:
        "Dashboard estatístico: gráficos, KPIs, filtros analíticos, listagens segmentadas.",
      reuniao: "Sabado,  31/05/2025",
    },
    {
      semana: "Semana 8",
      periodo: "07/06/2025 a 13/06/2025",
      atividade:
        "Testes gerais de usabilidade, validação funcional, correção de bugs, ajustes visuais e otimização de desempenho.",
      reuniao: "Sabado,  07/06/2025",
    },
    {
      semana: "Semana 9",
      periodo: "14/06/2025 a 20/06/2025",
      atividade:
        "Deploy final em ambiente online, verificação de segurança, documentação de entrega e preparação para apresentação final ao cliente.",
      reuniao: "Sabado,  14/06/2025",
    },
  ];

  //Resetar senha

  const onResetarSenhaSubmit = async () => {
    if (
      window.confirm(
        `Tem a certeza que deseja resetar a senha para o email: ${email} ?`
      )
    ) {
      try {
        setLoading(true);

        if (!validateEmail(email)) {
          setLoading(false);

          // Show a error toast
          toast.error("O email deve ser válido.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });

          return;
        }

        const res = await http.post("/resetar-senha", { email: email });

        if (res) {
          toast.success(res.data?.message, {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            onClose: () => {},
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("E-mail inválido, tente novamente!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          toast.error("Algo correu mal, tente novamente mais tarde!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const validateEmail = (email) => {
    // Use a regular expression for basic email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return verLogin ? (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
        integrity="sha512-1ycn6IcaQQ40/MKBW2W4NpNjK+0YtB9sQbVHZukdyU+uhs8wrYlOZK0z5E8o5SAxz7S4Y5gZ3Cq7T3On6pN1Vw=="
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />
      <div style={stylesLogin.page}>
        <div style={stylesLogin.container}>
          <img src={Applogo} alt="Ropeway Logo" style={stylesLogin.logo} />
          <h1 style={styles.title}>Login - (RW)</h1>
          <form onSubmit={handleSubmit(onSubmit)} style={stylesLogin.form}>
            <div style={stylesLogin.inputGroup}>
              <i className="fa fa-envelope" style={stylesLogin.inputIcon}></i>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={stylesLogin.input}
              />
            </div>
            <div style={stylesLogin.inputGroup}>
              <i className="fa fa-lock" style={stylesLogin.inputIcon}></i>
              <input
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={stylesLogin.input}
              />
            </div>

            {loading ? (
              <>
                <span style={stylesLogin.button}>
                  solicitando acesso aguarde...
                </span>
              </>
            ) : (
              <button type="submit" style={stylesLogin.button}>
                Entrar
              </button>
            )}

            <hr></hr>

            <button
              className="btn btn-primary account-btn"
              onClick={() => onResetarSenhaSubmit()}
            >
              {loading ? <Spinner /> : "Resetar senha"}
            </button>

            {/* <hr></hr>

            <span
              style={{ ...styles.button, marginBottom: 40 }}
              onClick={onLoginClick}
            >
              <i className="fa fa-calendar"></i> Ver Cronograma
            </span> */}
          </form>
        </div>

        <ToastContainer />
      </div>
    </>
  ) : (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
        integrity="sha512-1ycn6IcaQQ40/MKBW2W4NpNjK+0YtB9sQbVHZukdyU+uhs8wrYlOZK0z5E8o5SAxz7S4Y5gZ3Cq7T3On6pN1Vw=="
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />
      <div style={styles.page}>
        <div style={styles.container}>
          <img src={Applogo} alt="Ropeway Logo" style={styles.logo} />
          <h1 style={styles.title}>Sistema em Desenvolvimento</h1>
          <p style={styles.description}>
            O sistema <strong>Ropeway Crew Angola (RW)</strong> está actualmente
            em desenvolvimento. Esta página permite-lhe acompanhar as
            actualizações em tempo real através do nosso ambiente de testes
            hospedado na Vercel.
          </p>

          <hr></hr>

          <div style={{ overflowX: "auto" }}>
            <h2 style={{ textAlign: "center", marginBottom: 20 }}>
              Cronograma de Desenvolvimento
            </h2>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#28ace3", color: "white" }}>
                  <th style={cellStyle}>Semana</th>
                  <th style={cellStyle}>Período</th>
                  <th style={cellStyle}>Atividades Planeadas</th>
                  <th style={cellStyle}>Reunião de Feedback</th>
                </tr>
              </thead>
              <tbody>
                {cronograma.map((item, idx) => (
                  <tr
                    key={idx}
                    style={{
                      backgroundColor: idx % 2 === 0 ? "#f3f9fc" : "#ffffff",
                    }}
                  >
                    <td style={cellStyle}>{item.semana}</td>
                    <td style={cellStyle}>{item.periodo}</td>
                    <td style={cellStyle}>{item.atividade}</td>
                    <td style={cellStyle}>{item.reuniao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={styles.contactRow} className="mt-5">
            <div style={styles.contactItem}>
              <i className="fa fa-envelope" style={styles.icon}></i>
              <span>geral@ropeway.ao</span>
            </div>
            <div style={styles.contactItem}>
              <i className="fa fa-phone" style={styles.icon}></i>
              <span>+244 999 999 999</span>
            </div>
            <div style={styles.contactItem}>
              <i className="fa fa-map-marker" style={styles.icon}></i>
              <span>Luanda - Angola</span>
            </div>
          </div>

          <span
            style={{ ...styles.button, marginBottom: 40 }}
            onClick={onLoginClick}
          >
            Ir para login
          </span>
        </div>
      </div>
    </>
  );
}

const stylesLogin = {
  page: {
    backgroundImage: `linear-gradient(rgba(10, 10, 94, 0.9), rgba(10, 10, 94, 0.9)), url(${Applogo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    padding: "40px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    backgroundColor: "#ffffff",
    color: "#0a0a5e",
    borderRadius: "20px",
    padding: "40px",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.3)",
  },
  logo: {
    width: "100px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "30px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f1f5f9",
    borderRadius: "8px",
    padding: "10px 15px",
  },
  inputIcon: {
    marginRight: "10px",
    color: "#28ace3",
  },
  input: {
    flex: 1,
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    fontSize: "14px",
    color: "#0a0a5e",
  },
  button: {
    backgroundColor: "#28ace3",
    color: "#ffffff",
    padding: "12px",
    borderRadius: "30px",
    border: "none",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background 0.3s",
  },
};

const styles = {
  page: {
    backgroundColor: "#0a0a5e",
    minHeight: "100vh",
    padding: "40px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  container: {
    backgroundColor: "#ffffff",
    color: "#0a0a5e",
    borderRadius: "20px",
    padding: "40px",
    maxWidth: "85%",
    textAlign: "center",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.2)",
  },
  logo: {
    width: "120px",
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  description: {
    fontSize: "16px",
    marginBottom: "30px",
    lineHeight: "1.6",
  },
  contactRow: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap",
    marginBottom: "30px",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
  },
  icon: {
    color: "#28ace3",
  },
  button: {
    display: "inline-block",
    backgroundColor: "#28ace3",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "30px",
    textDecoration: "none",
    fontWeight: "bold",
    transition: "background 0.3s",
    cursor: "pointer",
  },
};

const cellStyle = {
  padding: "12px 16px",
  border: "1px solid #ddd",
  verticalAlign: "top",
};
